import {
  BooleanField,
  Show,
  TextField,
  SimpleShowLayout,
  DateField,
  UrlField,
  NumberField,
  SelectField,
} from "react-admin";
import { FileInputSingleLarge } from "../fileinputs/eventFileUpload";

export const StoryShow = (props) => {
  return (
    <Show {...props}>
      <SimpleShowLayout>
        <TextField source="description" />
        <SelectField
          source="type"
          choices={[
            { id: "Video", name: "Video" },
            { id: "Image", name: "Image" },
          ]}
        />
        <FileInputSingleLarge source="thumbnail" title="Uploaded Thumbnail" />
        <FileInputSingleLarge source="link" title="Uploaded Link" />
        <DateField source="startTimestamp" locales="en-IN" />
        <DateField source="endTimestamp" locales="en-IN" />
        <NumberField source="duration" />
        <BooleanField source="isPromotion" />
      </SimpleShowLayout>
    </Show>
  );
};
